const STATUS_COLORS = {
  active: 'bg-accent-green/15 text-accent-green',
  paused: 'bg-accent-amber/15 text-accent-amber',
  completed: 'bg-accent-blue/15 text-accent-blue',
  planned: 'bg-text-muted/15 text-text-muted',
};

const COLUMNS = ['now', 'next', 'later', 'done'];

function editedAgo(iso) {
  if (!iso) return '';
  const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  if (days === 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 30) return `${days}d ago`;
  if (days < 365) return `${Math.floor(days / 30)}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}

export default function ProjectTile({
  project,
  onSelect,
  onColumnChange,
  onDragStart,
  onDragEnd,
  isDragging,
}) {
  return (
    <div
      draggable
      onDragStart={(e) => {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', project.id);
        onDragStart(project);
      }}
      onDragEnd={onDragEnd}
      onClick={() => onSelect(project)}
      className={`group cursor-pointer bg-bg-card border border-border-base rounded p-3 hover:border-accent-blue/40 transition ${
        isDragging ? 'opacity-40' : ''
      }`}
    >
      <div className="flex items-start justify-between gap-2 mb-1">
        <h4 className="text-sm font-semibold text-text-primary flex-1 leading-tight">
          {project.name}
        </h4>
        {project.status && (
          <span
            className={`text-[10px] px-1.5 py-0.5 rounded uppercase tracking-wide ${
              STATUS_COLORS[project.status] || STATUS_COLORS.planned
            }`}
          >
            {project.status}
          </span>
        )}
      </div>

      {project.summary && (
        <div className="text-xs text-text-secondary truncate mb-2">
          {project.summary}
        </div>
      )}

      <div className="mb-2">
        <div className="flex items-center justify-between text-[10px] text-text-muted mb-0.5">
          <span>progress</span>
          <span>{project.progress ?? 0}%</span>
        </div>
        <div className="h-1 bg-bg-input rounded overflow-hidden">
          <div
            className="h-full bg-accent-blue transition-all"
            style={{ width: `${project.progress ?? 0}%` }}
          />
        </div>
      </div>

      <div className="flex items-center justify-between text-[10px] text-text-muted">
        <span>edited {editedAgo(project.last_edited_at || project.updated_at)}</span>
        <select
          value={project.kanban_column}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => onColumnChange(project, e.target.value)}
          className="bg-bg-input border border-border-base rounded px-1 py-0.5 text-[10px] text-text-secondary focus:outline-none focus:border-accent-blue"
        >
          {COLUMNS.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
